import { Box, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { InspirationCardButton } from "web_myplann/Dashboard/Components/InspirationCardButton";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { INSPIRATION_CARDS } from "web_myplann/Inspiration/constants";
import { HorizontalScrollContainer } from "web_myplann/Shared/Components/HorizontalScrollContainer";
import { useHorizontalDragScroll } from "web_myplann/Shared/Hooks/useHorizontalDragScroll";

const PageResources = Resources.Dashboard.Inspiration;

export const InspirationSection: FC = () => {
	const { t } = useResource();
	const { inspiration } = useTheme();
	const navigate = useNavigate();
	const { scrollRef, onMouseDown, wasDragged } = useHorizontalDragScroll(
		inspiration.section.dragThreshold,
	);

	const handleCardClick = (cardId: string) => {
		if (wasDragged()) return;
		navigate(Routing.Inspiration.Detail.path(cardId));
	};

	return (
		<Stack>
			<Typography variant="sectionLabel">{t(PageResources.title)}</Typography>
			<HorizontalScrollContainer
				scrollRef={scrollRef}
				onMouseDown={onMouseDown}
				pb={inspiration.section.paddingBottom}
				pl={inspiration.section.paddingLeft}
				gap={inspiration.section.cardGap}
				sx={{ cursor: inspiration.section.cursor }}
			>
				{INSPIRATION_CARDS.map((card) => (
					<InspirationCardButton
						key={card.id}
						title={t(PageResources.Cards[card.titleKey])}
						image={card.image}
						onClick={() => handleCardClick(card.id)}
					/>
				))}
				<Box flexShrink={0} width={inspiration.section.endSpacerWidth} />
			</HorizontalScrollContainer>
		</Stack>
	);
};
